import React, { useState, useEffect } from 'react'
import Breadcrumb from '../../../components/partials/Breadcrumb';
import { BiCategory } from "react-icons/bi";
import { Alerts, GetMedia } from '../../../helpers';
import { Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaFileExport } from "react-icons/fa";
import ConfirmationDialog from '../../../components/cmp/ConfirmationDialog';
import ConfirmMultiDelete from '../../../components/cmp/ConfirmMultiDelete';

const breadcrumbs = [
  {
    id: 1,
    label: "Dashboard",
    link: "/",
  },
  {
    id: 2,
    label: "Media Library",
    link: "/app/media-library",
  },
];

const MediaLibrary = () => {
  const [isLoading, setLoading] = useState(true);
  const [mediaData, setMediaData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [singleMedia, setSingleMedia] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [delId, setDelId] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isSelectMultiple, setShowMultiselect] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filename, setFilename] = useState('');
  const [altText, setAltText] = useState('');

  const getData = async (crt_page, search = '') => {
    let resp = await GetMedia.getAllMedia(crt_page, 24, searchTerm);
    if (resp && resp.status) {
      if (crt_page === 1) {
        setMediaData(resp.data);
      } else {
        setMediaData(prevData => [...prevData, ...resp.data]);
      }
      setTotalPages(resp.totalPages);
      setLoading(false);
    }
  }


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setCurrentPage(1);
      getData(1, searchTerm);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);


  useEffect(() => {
    if (singleMedia) {
      setFilename(singleMedia.filename || '');
      setAltText(singleMedia.poster || '');
    }
  }, [singleMedia]);

  const handleUpdateClick = async (media_id) => {
    const data = {
      newFilename: filename,
      altText: altText
    };

    const resp = await GetMedia.udpateMediaContent(media_id, data);
    if (resp?.success) {
      Alerts.alertMessage(resp.data?.message, 'top-right', 'success');
      setMediaData(prevList =>
        prevList.map(item =>
          item.id === media_id ? { ...item, ...resp.data.data } : item
        )
      );
    } else {
      Alerts.alertMessage(resp?.message || "Something went wrong", 'top-right', 'error');
    }
  };

  const handleItemClick = (item) => {
    setSingleMedia(item);
  }


  const deleteRecord = async (id) => {
    let resp = await GetMedia.deleteMedia(id);
    if (resp && resp.status) {
      setSingleMedia(null);
      getData();
      Alerts.alertMessage(resp.message, 'top-right', 'success');
      setTimeout(() => {
        window.location.reload();
      }, 2000);

    } else {
      Alerts.alertMessage(resp.message, 'top-right', 'error');
    }
    setDelId(null);
    setShowDialog(false);
  }

  const showDialogBox = (id) => {
    setDelId(id);
    setShowDialog(true);
  }
  // const handleLoadMore = () =>{
  //   setCurrentPage(currentPage+1);
  // }
  const handleLoadMore = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    getData(nextPage, searchTerm);
  };

  const handleCheckboxChange = (id) => {
    setSelectedFiles((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((fileId) => fileId !== id)
        : [...prevSelected, id]
    );
  };

  const deleteSelectedFiles = async (ids) => {
    const resp = await GetMedia.deleteMultipleFiles({ ids: ids });
    if (resp && resp.status) {
      Alerts.alertMessage(resp.message, 'top-right', 'success');
      getData(currentPage);
      setSelectedFiles([]);
    } else {
      Alerts.alertMessage(resp.message, 'top-right', 'error');
    }

  };

  return (
    <>

      <div className="innerPageWrapper">
        <div className='container-fluid'>
          <div className='page-title'>
            <h2><BiCategory /> Media Library</h2>
            <div>
              <div className='media-actions'>
                <Link to="/app/media-library/create" className="btn btn-success"><FaPlus size={14} /> Add New</Link> 
              <Link to="/app/media-library/export" className="btn btn-primary"><FaFileExport size={14} /> Export</Link>
              {selectedFiles.length > 0 && (
                <ConfirmMultiDelete selectedFiles={selectedFiles} message={'Are you sure you want to delete files.'} handleDelete={deleteSelectedFiles} />
              )}
              {selectedFiles.length === 0 && (
                <button className="btn btn-danger btn-sm" onClick={() => setShowMultiselect(!isSelectMultiple)}>
                  <FaTrash size={15} /> Select Multiple ({selectedFiles.length})
                </button>
              )}
                <input
                type="text"
                className="form-control"
                placeholder="Search by filename"
                value={searchTerm}
                style={{ maxWidth:200 }}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              </div>
          
            
            </div>

          </div>
          {
            isLoading ? <div className='loader'>
              <img src='/images/loader.gif' alt='loader' />
            </div> : <div className='media-library'>
              <div className='row'>
                <div className={`${singleMedia ? 'col-md-9' : 'col-md-12'}`}>
                  <div className='row'>

                    {
                      mediaData.length > 0 ? mediaData.map((item) => {
                        return <div className='col-md-2 mb-20' key={item.id}>
                          {
                            isSelectMultiple && <input
                              type="checkbox"
                              className="select-checkbox"
                              checked={selectedFiles.includes(item.id)}
                              onChange={() => handleCheckboxChange(item.id)}
                            />
                          }

                          <a href='#' onClick={() => handleItemClick(item)}>
                            <div className='media-item'>

                              <div className='thumbnail'>
                                <div className='centered'>

                                  {
                                    item.file_type === 'image' && <img src={item.path} alt={item.filename} />
                                  }
                                  {
                                    item.file_type === 'video' &&
                                    <>
                                      <img src={'/images/video.svg'} alt={item.filename} className='icon' />

                                    </>
                                  }
                                  {
                                    item.file_type === 'text' && <img src={'/images/txt-file.png'} alt={item.filename} style={{ width: 100 }} />
                                  }


                                </div>
                                {item.file_type === 'video' && <div className='filename'>{item.filename}</div>}
                              </div>

                            </div>
                          </a>


                        </div>
                      }) : <p>File not found !</p>
                    }


                  </div>
                  {
                    mediaData.length > 0 && <div className='pagination'>
                      <button onClick={handleLoadMore} disabled={currentPage === totalPages} className={`load_more ${currentPage === totalPages ? 'dsb-btn' : ''}`}>
                        Load More
                      </button>
                    </div>
                  }


                </div>
                {
                  singleMedia ? <div className='col-md-3'>
                    <div className='media-sidebar'>
                      <h4>Media Details</h4>
                      <div className='media-description'>
                        <div className='mdImg'>
                          {
                            singleMedia.file_type === 'image' && <img src={singleMedia.path} alt={singleMedia.filename} />
                          }
                          {
                            singleMedia.file_type === 'video' && <video width="320" height="200" controls>
                              <source src={singleMedia.path} type="video/mp4" />
                            </video>
                          }
                          {
                            singleMedia.file_type === 'text' && <img src={'/images/txt-file.png'} alt={singleMedia.filename} style={{ width: 100 }} />
                          }

                        </div>
                        <div className='mdDetails'>
                          <div className='form-group'>
                            <label>File Path</label>
                            <input type='text' className='form-control' value={singleMedia.path} readOnly style={{ backgroundColor: '#e9e9e9' }} />
                          </div>

                          <div className='form-group'>
                            <label>Filename</label>
                            <input type='text' className='form-control'
                              value={filename}
                              onChange={(e) => setFilename(e.target.value)}
                            />
                          </div>
                          {
                            singleMedia.file_type === 'image' && <div className='form-group'>
                              <label>Alt Text</label>
                              <input type='text' className='form-control'
                                value={altText}
                                onChange={(e) => setAltText(e.target.value)}
                              />
                            </div>
                          }

                          <div className='form-group'>
                            <label>File Size</label>
                            <input type='text' className='form-control' value={singleMedia.size} readOnly style={{ backgroundColor: '#e9e9e9' }} />
                          </div>

                          <div className='form-group'>
                            <button type='button' className='btn btn-info btn-sm' style={{ marginRight: 10 }} onClick={() => handleUpdateClick(singleMedia.id)}>Update</button>
                            <button type='button' className='btn btn-danger btn-sm' onClick={() => showDialogBox(singleMedia.id)}>Delete</button>
                          </div>



                        </div>
                      </div>
                    </div>
                    {showDialog ? <ConfirmationDialog delId={delId} setShowDialog={setShowDialog} deleteRecord={deleteRecord} show={showDialog} message="Are you sure you want to delete this record." /> : null}
                  </div> : null
                }

              </div>

            </div>
          }
        </div>
      </div>
    </>
  )
}

export default MediaLibrary;